import React, { useState, useEffect, useRef } from 'react';
import { Form } from '@unform/web';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
// Importando servicos e componentes
import api from '~/services/api';
import history from '~/services/history';
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Load from '~/components/Load';

import { Container } from './styles';

export default function IntegracaoEdit({ match }) {
  const inputRef = useRef(null);
  const [dado, setDado] = useState([]);
  const [carregar, setCarregar] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function getIntegacao() {
      setLoading(true);
      const { id } = match.params;

      const response = await api.get(`/integracao/${id}`);
      setDado(response.data);
      setLoading(false);
    }
    getIntegacao();
  }, [match]);

  async function handlerSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
        url: Yup.string().required('Preencha o campo url'),
        post: Yup.string().required('Preencha o campo post'),
        url_produtos: Yup.string(),
        url_corretores: Yup.string(),
        parametro: Yup.string(),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/integracao/${dado.id}`, {
        name: data.name,
        url: data.url,
        post: data.post,
        url_produtos: data.url_produtos,
        url_corretores: data.url_corretores,
        parametro: data.parametro,
      });

      toast.success('Integração cadastrada com sucesso');
      history.push('/integracao');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Integração já foi cadastrada.');
      }
    } finally {
      setCarregar(false);
    }
  }

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Editar Integração</h4>
      <Card>
        <Form
          ref={inputRef}
          onSubmit={handlerSubmit}
          autoComplete="off"
          initialData={dado}
        >
          <Input
            icon="MdBusiness"
            label="Base URL da api"
            name="url"
            type="url"
          />
          <Input
            icon="MdBusiness"
            label="URL de listagem dos corretores"
            name="url_corretores"
            type="text"
          />
          <Input
            icon="MdBusiness"
            label="URL de listagem dos produtos"
            name="url_produtos"
            type="text"
          />
          <Input
            icon="MdBusiness"
            label="Parâmetro do post"
            name="post"
            type="text"
            required
          />
          <Input
            icon="MdBusiness"
            label="Parâmetro"
            name="parametro"
            type="text"
            required
          />
          <Input
            icon="MdBusiness"
            label="Nome"
            name="name"
            type="text"
            required
          />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
    </Container>
  );
}

IntegracaoEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};
